module.exports = __webpack_public_path__ + "static/media/family.c3133596.png";